<template lang="pug">
  div
    .headbar(v-if="!$from")
      .left-icon(@click='goHome')
        img.logoIcon(src="/static/head_logo_new.png")
        i.icon.DYT_icon_font.icon-shouye
      .right-icon(@click='goCenter')
        i.icon.DYT_icon_font.icon-gerenzhongxin
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    goHome() {
      if (this.$userDetail) {
        if (navigator.userAgent.indexOf('Alipay') > -1 || navigator.userAgent.indexOf('AlipayClient') > -1) {
          this.$router.push('/home_new')
        } else {
          this.$router.push('/home')
        }
      } else if (localStorage.getItem('dzjkk')) {
        window.wx.miniProgram.navigateTo({
          url: `/pages/yunnancn/yunnancn`
        })
      } else {
        if (navigator.userAgent.indexOf('Alipay') > -1 || navigator.userAgent.indexOf('AlipayClient') > -1) {
          this.$router.push('/home_new')
        } else {
          this.$router.push('/platIndex')
        }
      }
    },
    goCenter() {
      if (this.$userDetail) {
        if (navigator.userAgent.indexOf('Alipay') > -1 || navigator.userAgent.indexOf('AlipayClient') > -1) {
          this.$router.push('/ucenter_new')
        } else {
          this.$router.push('/ucenter')
        }
      } else {
        if (navigator.userAgent.indexOf('Alipay') > -1 || navigator.userAgent.indexOf('AlipayClient') > -1) {
          this.$router.push('/ucenter_new')
        } else {
          this.$router.push('/ucenterPlatIndex')
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../styles/base.less';

.headbar {
  height: 0.6rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid @bd_color;
  background-color: #fff;
  padding: 0.2rem;
  .icon {
    width: 1rem;
    text-align: center;
    font-size: 0.6rem;
    margin: 0 0.2rem;
    color: @sub_color;
  }
  .left-icon {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    margin-left: 1em;
    i {
      width: 0;
      margin-left: 0;
    }
  }
  .logoIcon {
    text-align: center;
    width: 2rem;
    margin-bottom: 0.1rem;
  }
}
</style>
